import * as React from 'react'
import { useLoaderData, Navigate,
        Link as RouterLink } from 'react-router-dom'
import { Paper, Typography, Box, Grid, Breadcrumbs, Link, Button } from '@mui/material'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { setData } from '../../../misc/other'
import axios from 'axios'
import CheckIcon from '@mui/icons-material/Check'



const columns = [
    {field: 'id', headerName:'ID', flex: 1},
    {field: 'original_creditor', headerName: 'Originator', flex: 4.5 },
    {field: 'original_account_number', headerName: 'Account #', flex: 2},
    {field: 'account_balance', description: 'This is not the ammount you will pay after you Name Your Settlement',
    headerName: 'Balance ($)', flex: 4 },
    {field: 'account_status', headerName: 'Status', flex: 4}
]

export const AdminUserAccounts = () => {


let loaderData = useLoaderData()



const data = setData(loaderData)

let promoCodes = loaderData.promo_codes_used.promoCodes || []


window.localStorage.setItem('userpromocodes', JSON.stringify(promoCodes))
const context = JSON.parse(window.localStorage.getItem('usercontext'))





let activeAccounts = 0

for(let a=0; a<data.accounts.length; a++){
    

    if (data.accounts[a].account_balance == null){
        data.accounts[a].account_balance = data.accounts[a].principal
    }

    if (data.accounts[a].account_status == null){
        data.accounts[a].account_status = 'Ready to Settle'

       
    }

    if (data.accounts[a].account_status !== "PAID" && data.accounts[a].account_status !== "Reconciled") {
       
        activeAccounts += 1
    }
    

}




    const [accountSelected, setAccountSelected] = React.useState([])
    const [accountStatus, setAccountStatus] = React.useState(null)
    const [disableButton, setDisableButton] = React.useState(true)
    const [totalDue, setTotalDue] = React.useState(0)
    const [pathName, setPathName] = React.useState('/admin/customercare/confirmaccounts')
    const [isReady, setIsReady] = React.useState(false)
    const [isSubmitting, setIsSubmitting] = React.useState(false)

    React.useLayoutEffect(()=>{
        
        const whereToGo =(account_status)=> {
            switch(account_status) {
                
                case 'Settled':
                case 'Money Order':
                case 'Partial' : 
                case 'Recurring':                       
                    setPathName('/admin/customercare/payment/' );
                    break
                case '1099-C':    
                case 'Already_Settled' :
                case 'Bankruptcy' :
                case 'Deceased' :
                case 'Ready to Settle' :    
                case 'Wrong_Identity' :
                
                                 
                    setPathName('/admin/customercare/confirmaccounts')
                    break
                
                case 'PAID':
                case 'Reconciled':
                    
                   return setDisableButton(true);
                
                case 'Confirmed' :
                        
                    setPathName('/admin/customercare/settlement')
                    break
                
                default: 
                setPathName('/admin/customercare/confirmaccounts')
                break
                }
        
        }


            if(accountStatus == null){
                setAccountStatus('Ready to Settle')
                
            
            }
                    
            else{
        
        
    for(let j=0; j<accountSelected.length; j++){
     if (accountSelected[j].account_status != accountStatus){
        
        setDisableButton(true)

    }else{
        
        setDisableButton(false)
        whereToGo(accountStatus)}
}

            }
    
    },[accountSelected, accountStatus])


    const buttonClick = () => {
        setIsSubmitting(true)
        let almostReadyAccounts = accountSelected
        
        context.active_accounts = activeAccounts
        context.accounts_settled = accountSelected.length
        window.localStorage.setItem('usercontext',JSON.stringify(context))
       
        for(let r=0; r<almostReadyAccounts.length; r++){
            almostReadyAccounts[r].per_of_settlement =Number((almostReadyAccounts[r].account_balance/totalDue).toFixed(2)) 
        }
        
        setAccountSelected(almostReadyAccounts)

        axios({
            method: "POST",
            url: 'api/oracle3/persettlement',
            data: {almostReadyAccounts, active_accounts: activeAccounts }
        }).then(res=>{
            
            for(let m=0; m<almostReadyAccounts.length; m++){
                almostReadyAccounts[m].settlement_per = res.data[m].settlement_per
               
            }
            setAccountSelected(almostReadyAccounts)
            setIsReady(true)

        })

        
    }

    const rowClick = (row) =>{
        const newArray = Array.from(row.ids)
           
        if(!newArray.length){setDisableButton(true)}

        else{
        
        let rowsSelected = []
        let i = 0
        let total = 0    
        
        while (i < (data.accounts.length)){           
        if (newArray.includes(data.accounts[i].id)){
                      rowsSelected.push(data.accounts[i])
                      total += data.accounts[i].account_balance
                      setAccountSelected(rowsSelected)
                      setAccountStatus(rowsSelected[0].account_status)
                    
                      setTotalDue(total)
                      
                      
        }
        
        i++
        
           }
           
        }
    }

    let accountStatusWarning;
if(isReady) return(<Navigate  to={pathName} state={{accounts: accountSelected, totalDue: totalDue, promoCodesUsed: promoCodes}}/>)

    if (disableButton) 
        {accountStatusWarning = <React.Fragment><Grid container direction='row' sx={{justifyContent: 'flex-end'}}><Grid size={{lg: 8, md: 8, sm: 10}}> <Typography variant='h6'color='primary' gutterBottom={true}> *Select items with the same account status or select one debt.</Typography> </Grid></Grid></React.Fragment>}
        else{<Grid></Grid>}

return(
    <Box sx={{minHeight:'75vh', mt: 15, mb: 2}}>
        <Breadcrumbs sx={{mb: 3}}>
        <Link underline='hover' component={RouterLink} to='../dashboard'>Dashboard</Link> 
        <Link underline='hover' component={RouterLink} to='../customercare'>Search </Link> 
        <Link underline='hover' component={RouterLink} to='../customercare/confirm'>Confirm Info</Link>
    </Breadcrumbs>  
        <Grid container direction='row'>
            <Grid size={{xs: false, sm: 1, md: 1, lg: 2}}></Grid>
            <Grid size={{xs: 12, sm: 11, lg: 9, xl: 8}}>
                <Typography color='secondary' variant='h6'  gutterBottom={true}>“Check the box(s) to the left of the items you want to settle, then click CONTINUE at the bottom of this page. All items selected must have the same status</Typography>
            </Grid>
        </Grid>  

   <Grid container direction='row' sx={{alignItems:'center', justifyContent: 'center', justifyItems:'center', alignContent: 'center'}}>
    <Grid size={{xs: 12, sm: 9, md: 9, lg: 8}}>
        <Paper>
            <DataGridPro
                   rows={data.accounts}
                   columns={columns} 
                   autoPageSize={true} 
                   checkboxSelection 
                   columnBufferPx={150} 
                   hideFooter={false}
                   onRowSelectionModelChange={rowClick} 
                                    
                   />
        </Paper>
    </Grid>
   </Grid>
<Grid container direction='row' sx={{mt: 2}}>
<Grid size={{xs: 6, sm: 8, md: 8, lg: 9}}>
</Grid>
<Grid>
<Button
        loading={isSubmitting}
        loadingPosition='end'
        variant='contained' 
        color='secondary'
        size = 'large'
        onClick={buttonClick}
        type = 'button' 
        disabled={disableButton || !accountSelected.length} 
        endIcon= {<CheckIcon/>}>
            CONTINUE</Button> 
</Grid>
{accountStatusWarning}
</Grid>
<Grid container direction='column' sx={{alignItems:'center', justifyItems:'center'}}  > 
</Grid>
</Box>
)

}